import { ALL_LAYOUT_ARGS, Metadata, pick } from '../../../../utils/spds/metadata';
import Super from '../base.gjs';
import VariableLayout from '../../layout/variable.gjs';
import styles from './footer.module.scss';

const METADATA = Metadata.define({
  description: 'Footer for menus',
  extends: [
    pick(ALL_LAYOUT_ARGS, [
      { name: 'alignItems', defaultValue: 'center' },
      { name: 'gap', defaultValue: '8px' },
      { name: 'justifyContent', defaultValue: 'space-between' },
    ]),
  ],
  name: 'Menu Footer',
});

export default class SpdsCoreMenuFooter extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-menu-footer';
  styles = styles;

  get alignItems() {
    return this.argOrDefault('alignItems');
  }

  get column() {
    return this.argOrDefault('column');
  }

  get gap() {
    return this.argOrDefault('gap');
  }

  get justifyContent() {
    return this.argOrDefault('justifyContent');
  }

  <template>
    <VariableLayout
      @alignItems={{this.alignItems}}
      @column={{this.column}}
      @gap={{this.gap}}
      @justifyContent={{this.justifyContent}}
      class={{this.classes}}
      data-test-spds-menu-footer
      {{this.validateArguments}}
      ...attributes
    >
      {{yield}}
    </VariableLayout>
  </template>
}

export const SPDS_CORE_MENU_FOOTER_METADATA = SpdsCoreMenuFooter.metadata;
